import { InputHTMLAttributes, ButtonHTMLAttributes } from 'react';
import styled from 'styled-components';

export const SearchContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 2.75rem; /* Base height */
  border-radius: ${(props) => props.theme.sizes.borderRadius};
  border: 1.5px solid ${(props) => props.theme.colors.border};
  background-color: ${(props) => props.theme.colors.background};
  overflow: hidden;
  transition: border-color ${(props) => props.theme.transitions.fast},
              box-shadow ${(props) => props.theme.transitions.fast};

  &:focus-within {
    border-color: ${(props) => props.theme.colors.primary};
    box-shadow: ${(props) => props.theme.shadows.focus};
  }
`;

export const SearchInput = styled.input<InputHTMLAttributes<HTMLInputElement>>`
  flex: 1;
  min-width: 0;
  padding: 0.5rem 1rem;
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  font-family: 'Inter', sans-serif;
  color: ${(props) => props.theme.colors.title};
  background-color: transparent;
  border: none;
  outline: none;
  box-sizing: border-box;

  &::placeholder {
    color: ${(props) => props.theme.colors.grayScale.variation4};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const SearchIcon = styled.button<ButtonHTMLAttributes<HTMLButtonElement>>`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  width: 2.75rem;
  color: #ffffff;
  background-color: ${(props) => props.theme.colors.primary};
  border: none;
  outline: none;
  cursor: pointer;
  transition: background-color ${(props) => props.theme.transitions.fast};
  font-size: 20px;

  &:hover:not(:disabled) {
    background-color: ${(props) => props.theme.colors.primaryHover};
  }

  &:disabled {
    background-color: ${(props) => props.theme.colors.border};
    color: ${(props) => props.theme.colors.textMuted};
    cursor: not-allowed;
  }
`;
